import { useEffect, useState } from 'react'
import { useUser } from 'reactfire'

// Mirrors useIsAutomationAdmin: gates the global Chatwoot operator inbox
// behind the `chat_agent` rollout claim so onboarded operators can be granted
// access without being admins.
// TODO: remove chat_agent gate once Chatwoot is GA for all operators.
export function useIsChatAgent(): {
  isChatAgent: boolean
  loading: boolean
} {
  const { data: user } = useUser()
  const [state, setState] = useState({
    isChatAgent: false,
    loading: true,
  })

  useEffect(() => {
    if (!user) {
      setState({ isChatAgent: false, loading: true })
      return
    }
    let cancelled = false
    user
      .getIdTokenResult()
      .then((result) => {
        if (cancelled) return
        const { claims } = result
        // Intentionally checks only the *impersonator's* original claim, not
        // the impersonated user's. An admin impersonating a chat_agent must
        // NOT gain chat access — only the impersonator's own privilege counts.
        const isChatAgent = claims.impersonating
          ? claims.impersonator_chat_agent === true
          : claims.chat_agent === true
        setState({ isChatAgent, loading: false })
      })
      .catch(() => {
        if (cancelled) return
        setState({ isChatAgent: false, loading: false })
      })
    return () => {
      cancelled = true
    }
  }, [user])

  return state
}
